var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-sheet",
    {
      staticClass: "pa-1 fill-height",
      class: { bordered: _vm.selected },
      attrs: { elevation: "2", rounded: "", color: "secondarybackground" }
    },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-space-between" },
        [
          _vm.title
            ? _c("h5", { staticClass: "pa-2 text-center" }, [
                _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("title"),
          _vm._v(" "),
          _vm._t("refresh")
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }